import { BorderBox, Box, FlexBox, Rhythm, Text } from '@trmediaab/zebra';
import { Money } from '@trmediaab/zebra-components';

import type { CheckoutState } from '../../state';
import {
  getProductLineItems,
  getShippingLineItem,
} from '../../utils/orderUtils';
import Card from '../Card';
import Layout from '../Layout';

interface SpecItemProps {
  label: string;
  value: React.ReactNode;
  fontWeight?: string;
}

const SpecItem = ({ label, value, fontWeight }: SpecItemProps) => (
  <FlexBox alignItems="baseline">
    <Text fontWeight={fontWeight}>{label}</Text>
    <BorderBox borderBottom="1" flex="1" mx="1"></BorderBox>
    <Text fontWeight={fontWeight}>{value}</Text>
  </FlexBox>
);

interface ShippingSummaryCardProps {
  order: NonNullable<CheckoutState['order']>;
  isFinalShipping: boolean;
}

/* TODO show vat perc. Calculate? Add to order? Use product vat?  */
const ShippingSummaryCard = ({
  order,
  isFinalShipping,
}: ShippingSummaryCardProps) => {
  const productLineItems = getProductLineItems(order);
  const shippingLineItem = getShippingLineItem(order);

  // Not a product with shipping, ignore
  if (shippingLineItem == null) {
    return null;
  }

  if (productLineItems == null) {
    throw new Error(`Order ${order.id} has no product line items`);
  }

  const { totalPrice, totalVAT } = order;

  return (
    <Layout.area area="shipping">
      <Card variant="secondary" fillHeight>
        <FlexBox flexDirection="column" height="100%">
          <Rhythm between="3">
            <Text fontWeight="bold" fontSize={{ md: 3 }}>
              Att betala
            </Text>
            <Box>
              <SpecItem
                label="Antal"
                value={productLineItems.reduce((sum, p) => sum + p.quantity, 0)}
              />
              <SpecItem
                label="Pris"
                value={
                  <Money
                    value={productLineItems.reduce(
                      (sum, p) => sum + p.price * p.quantity,
                      0,
                    )}
                  />
                }
              />
              <SpecItem
                label={`Porto ${!isFinalShipping ? 'från' : ''}`}
                value={
                  <Money
                    value={shippingLineItem.price * shippingLineItem.quantity}
                  />
                }
              />
            </Box>
          </Rhythm>
          <Box mt="auto">
            <SpecItem
              label="Total"
              value={<Money value={totalPrice} />}
              fontWeight="bold"
            />
            <SpecItem label="Varav moms" value={<Money value={totalVAT} />} />
          </Box>
        </FlexBox>
      </Card>
    </Layout.area>
  );
};

export default ShippingSummaryCard;
